/**
 * @fileoverview Instancia configurada de axios para comunicación con API Munzen
 * @author Omar Sánchez Martinez
 * @since 15/10/2025
 */

import axios from 'axios';
import { apiConfig } from './config';
import {
  requestInterceptor,
  requestInterceptorError,
  responseInterceptor,
  responseInterceptorError,
} from './interceptors';

/**
 * Instancia de axios configurada para API Munzen
 *
 * Configuración:
 * - baseURL: Obtenida de VITE_MUNZEN_API_URL
 * - timeout: 60 segundos
 * - headers: Content-Type application/json
 *
 * Interceptors activos:
 * - Request: Autenticación automática (Bearer token) + Refresh preventivo
 * - Response: Manejo centralizado de errores HTTP
 *
 * Funcionalidades:
 * - ✅ Autenticación automática con Bearer token
 * - ✅ Refresh preventivo de tokens (60s antes de expirar)
 * - ✅ Manejo de race conditions con cola de promesas
 * - ✅ Manejo automático de errores por código de estado
 * - ✅ Logout automático en errores 401 y refresh fallido
 * - ✅ Redirecciones automáticas (403, 404)
 *
 * @example
 * // Uso básico
 * import { apiMunzen, isApiError } from '@/app/api/apiMunzen/index';
 *
 * try {
 *   // Refresh automático si el token está próximo a expirar
 *   const response = await apiMunzen.get('/endpoint');
 *   console.log(response.data);
 * } catch (error) {
 *   if (isApiError(error)) {
 *     console.error(error.dataError);
 *     console.error(error.status);
 *   }
 * }
 */
export const apiMunzen = axios.create(apiConfig);

// ✅ FASE 2: Request interceptor (autenticación)
// ✅ FASE 4: Refresh preventivo integrado en request interceptor
apiMunzen.interceptors.request.use(requestInterceptor, requestInterceptorError);

// ✅ FASE 3: Response interceptor (manejo de errores)
apiMunzen.interceptors.response.use(responseInterceptor, responseInterceptorError);
